import { FamilyMember } from "@models/family-member";

export function formatName<
  T extends { firstName?: string; lastName?: string; nickname?: string },
>(person: T) {
  if (!person) {
    return "";
  }
  return (
    person.nickname ||
    `${person.firstName || ""}${person.lastName ? " " + person.lastName : ""}`
  );
}

export function formatNameWithRelation<
  T extends {
    firstName?: string;
    lastName?: string;
    nickname?: string;
    familyMember?: FamilyMember;
  },
>(person: T) {
  if (!person) {
    return "";
  }
  return `${formatName(person)}${person.familyMember ? ` - ${person.familyMember.relation}` : ""}`;
}

export function formatElapsedTime(milliseconds: number): string {
  if (!milliseconds) {
    return "00:00";
  }
  const seconds = Math.floor(milliseconds / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);

  const formattedMinutes = String(minutes % 60).padStart(2, "0");
  const formattedSeconds = String(seconds % 60).padStart(2, "0");

  let result = `${formattedMinutes}:${formattedSeconds}`;

  if (hours) {
    const formattedHours = String(hours).padStart(2, "0");
    result = `${formattedHours}:${result}`;
  }
  return result;
}
